import apiService from '../../../services/api-client';
import { DeleteUserResponse } from '../interfaces/delete-user';
import { GetUserResponse } from '../interfaces/get-user';
import { GetUsersParams, GetUsersResponse } from '../interfaces/get-users';
import { PutUserPayloadRequest, PutUserResponse } from '../interfaces/put-user';
import { PostUserPayloadRequest, PostUserResponse } from '../interfaces/post-user';

export const usersApiService = {
  async getUsers(params: GetUsersParams) {
    const { data } = await apiService().get<GetUsersResponse>(`users`, {
      params: { ...params },
    });
    return  data;
  },
  async getUser(id: number) {
    const { data } = await apiService().get<GetUserResponse>(
      `user/${id}`
    );
    return data;
  },
  async postUser(body: PostUserPayloadRequest) {
    const { data } = await apiService().post<PostUserResponse>(
      `user`,
      body,
    );
    return data;
  },
  async putUser(id: number, body: PutUserPayloadRequest) {
    const { data } = await apiService().put<PutUserResponse>(
      `user/${id}`,
      body,
    );
    return data;
  },
  async deleteUser(id: number) {
    const { data } = await apiService().delete<DeleteUserResponse>(
      `user/${id}`
    );
    return data;
  },
};
